import { createSlice } from "@reduxjs/toolkit";

import initialState from "./state";
import { fetchAnnouncementQuery } from "./actionCreator";

export const announcementQuerySlice = createSlice({
  name: "announcementQuery",
  initialState,
  reducers: {
    setPaginationModel(state, action) {
      state.page = action.payload.page;
      state.limit = action.payload.pageSize;
    },
    resetPaginationModel(state, action) {
      state.page = 0;
      state.limit = 25;
    },
    setSearchKey(state, action) {
      state.searchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAnnouncementQuery.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchAnnouncementQuery.fulfilled, (state, action) => {
      console.log("action  announcement", action.payload);
      state.isLoading = false;
      state.data = action.payload?.data;
      state.error = null;
      state.total = action.payload?.totalCount;
    });
    builder.addCase(fetchAnnouncementQuery.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});

export const {
  setPaginationModel,
  resetPaginationModel,
  setSearchKey,
} = announcementQuerySlice.actions;
export default announcementQuerySlice.reducer;
